<section class="users-view">
  <!-- Media object starts -->
  <div class="row">
    <div class="col-12 col-sm-7">
      <div class="media d-flex align-items-center">
        <a href="javascript:;">
          <img
            *ngIf="!courseData"
            src="assets/MeanderLIVE-icon.png"
            alt="user
            view avatar"
            class="users-avatar-shadow rounded"
            height="64"
            width="64"
          />
          <img
            *ngIf="courseData"
            [src]="imageUrl+courseData.image"
            alt="user
            view avatar"
            class="users-avatar-shadow rounded"
            height="64"
            width="64"
          />
        </a>
        <div class="media-body ml-3">
          <h4>
            <span class="users-view-name mr-1">{{
              courseData?.title
            }}</span>
            <!-- <span class="text-muted font-medium-1">
                <span>@</span>
                <span class="users-view-username">dean3004</span>
              </span> -->
          </h4>
          <span class="mr-1">ID:</span>
          <span class="users-view-id">{{
            courseData?._id.substring(courseData?._id.length - 6)
          }}</span>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-5 d-flex justify-content-end align-items-center">
      <!-- <a
        href="javaScript:void(0);"
        class="btn btn-sm bg-light-secondary mr-2 px-3 py-1"
        ><i class="ft-mail"></i
      ></a>
      <a
        href="javaScript:void(0);"
        class="btn btn-sm bg-light-secondary mr-2 px-3 py-1"
        >Profile</a
      > -->
      <a
        [routerLink]="['/course/course-edit', courseData?._id]"
        class="btn btn-sm btn-primary px-3 py-1"
        >Edit</a
      >
    </div>
  </div>
  <!-- Media object ends -->

  <div class="row">
    <div class="col-12">
      <!-- Card data starts -->
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-xl-4">
                <table class="table table-borderless">
                  <tbody>
                    <tr>
                      <td>Name :</td>
                      <td>{{ courseData?.title }}</td>
                    </tr>
                    <tr>
                      <td>About :</td>
                      <td>{{ courseData?.about }}</td>
                    </tr>
                    <tr>
                      <td>Fees :</td>
                      <td>{{ courseData?.total_fees }}</td>
                    </tr>
                    <tr>
                      <td>Registered :</td>
                      <td>{{ courseData?.created_at | date: "mediumDate" }}</td>
                    </tr>
                    <tr>
                      <td>Latest Activity :</td>
                      <td class="users-view-latest-activity">
                        {{ courseData?.updated_at | date: "mediumDate" }}
                      </td>
                    </tr>
                   
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Card data ends -->
    </div>
    <div class="col-12">
      <!-- User detail starts -->
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <div class="col-12">
              <div class="table-responsive">
                <table class="table table-borderless">
                  <tbody>
                    <h5 class="mb-2 text-bold-500">
                      <i class="ft-info mr-2"></i> Course Info
                    </h5>
                    <tr>
                      <td>Announcements :</td>
                      <td>{{ courseData?.announcements }}</td>
                    </tr>
                    <tr>
                      <td>Batch :</td>
                      <td>{{ courseData?.batch_ids?.name }}</td>
                    </tr>
                    <tr>
                      <td>Benifits :</td>
                      <td [innerText]="courseData?.benifits"></td>
                    </tr>
                    <tr>
                      <td>Category :</td>
                      <td>{{ courseData?.course_category?.displayname}}</td>
                    </tr>
                    <tr>
                      <td>Course Skill :</td>
                      <td><span *ngFor="let skill"></span></td>
                    </tr>                   
                    <tr>
                      <td>Course Tag :</td>
                      <td>{{ courseData?.course_tags?.displayname}}</td>
                    </tr>
                    <tr>
                      <td>Notes :</td>
                      <td [innerText]="courseData?.notes"></td>
                    </tr>
                    

                    <!-- <tr>
                        <td>E-mail:</td>
                        <td>{{courseData?.email}}</td>
                      </tr> -->
                  </tbody>
                </table>
              </div>

              <!-- <tr>
                        <td>Contact:</td>
                        <td>{{userData?.phoneNumber}}</td>
                      </tr> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- User detail ends -->
  </div>
</section>
